import React, { useEffect } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

export default function OrderBySupplierGraph({ summaryReports }) {
  let scmObj = summaryReports?.DecisionAnalysis?.supplierOrderInfos;
  let stackSeries = [];
  let max = 0;
  
  // Iterate over scmObj to determine the maximum length
  for (const property in scmObj) {
    if (Array.isArray(scmObj[property]) && scmObj[property].length > max) {
      max = scmObj[property].length;
    }
  }
  
  // Create empty series with unique names
  for (let i = 1; i <= max; i++) {
    stackSeries.push({ name: `${i} Order`, data: [], color: "" });
  }
  
  // Populate series data based on scmObj
  for (const property in scmObj) {
    for (let i = 0; i < max; i++) {
      if (scmObj[property][i] !== undefined) {
        stackSeries[i].data.push(scmObj[property][i].UnitsOrdered);
      } else {
        stackSeries[i].data.push(null);
      }
    }
  }
  
  function applyOrderBySupplierAccessibility(chart) {
    if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector("svg");
      if (svg) {
        setTimeout(() => {
        svg.setAttribute("role", "img");
        svg.setAttribute("aria-label", "Grouped stacked bar chart showing component units delivered by each supplier.");

        const oldDesc = svg.querySelector("desc");
        if (oldDesc) oldDesc.remove();

        const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
        desc.textContent = "This chart shows the number of component units delivered by various suppliers. Each bar represents a supplier, and the colored segments within each bar represent different types of components delivered.";
        svg.insertBefore(desc, svg.firstChild);
        },0);
      }
    }
  }

  var chart = {
    type: "column",
    events: {
      render: function () {
        applyOrderBySupplierAccessibility(this);
      },
      redraw: function () {
        applyOrderBySupplierAccessibility(this);
      }
    }
  };
  var title = {
    text: "Order by Supplier",
    align: "left",
    style: {
      fontSize: "14px",
    },
  };
  var credits = {
    enabled: false, // Disable the Highcharts bottom link
  };
  var tooltip = {
    formatter: function () {
      let tooltipText;
      for (let i = 0; i < stackSeries.length; i++) {
        let seriesname = "Units Ordered";
        let orderStatus = scmObj[this.x][Number(this.series.name.split(" ")[0]) - 1].OrderStatus//.filter((item)=> item.UnitsOrdered == this.y)[0].OrderStatus;
        tooltipText = `<strong>${this.x}</strong>` + '<br/>';
        tooltipText += '<span style="color:' + this.point.color + ';">' + `${seriesname}` + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</strong>' + '<br><span style="color:' + this.point.color + ';">Status:</span><strong style="float:right;">' + `${orderStatus}` + '</strong>';
        return tooltipText;
      }
    },
    borderWidth: 2,
    style: {
      borderColor: function () {
        return this.point.color; // Set the tooltip box border color to match the point color
      },
      opacity: 0.9,
      fontSize: '14px',
    }
  };
  var legend = {
    enabled: true,
    align: "left",
    itemStyle: {
      fontWeight: "bold",
      fontSize: "11px",
    },
  };

  var plotOptions = {
    column: {
      stacking: "normal",
    },
    series: {
      events: {
        legendItemClick: function () {
          return false;
        }
      }
    }
  };
  var xAxis = {
    categories: summaryReports?.DecisionAnalysis?.supplierOrderInfos ? Object.keys(summaryReports?.DecisionAnalysis?.supplierOrderInfos) : null,
    title: {
      text: 'Supplier Name',
    },
    lineColor: '#EFEFEC',
    labels: {
      step: 1,
      padding: 0,
      rotation: -45,
    },
  }
  var yAxis = {
    allowDecimals: false,
    crosshair: true,
    min: 0,
    lineWidth: 1,
    lineColor: "#EFEFEC",
    tickLength: 10,
    tickWidth: 1,
    tickColor: "#EFEFEC",
    title: {
      text: "Component Units Delivered"
    }
  }
  var series = stackSeries;
  var accessibility = {
    enabled: true,
    screenReaderSection: {
      beforeChartFormat: '' // disables their auto "Interactive chart" label
    }
  };
  var json = {};
  json.chart = chart;
  json.credits = credits;
  json.title = title;
  json.tooltip = tooltip;
  json.legend = legend;
  json.series = series;
  json.xAxis = xAxis;
  json.yAxis = yAxis;
  json.plotOptions = plotOptions;
  json.accessibility = accessibility;
  const initGraph = () => {
    Highcharts.chart("OrderSupplier", json);
  };
  useEffect(() => {
    initGraph();
    //console.log(summaryReports?.DecisionAnalysis?.supplierOrderInfos) 
  }, [summaryReports]);
  return (
    <div
      id="OrderSupplier"
      style={{ height: "500px" }}
      title={title.text}
      aria-label="Order Supplier Graph"
      className="OrderSupplier"
    ></div>
  );
}
